import styled, { css } from 'styled-components';
import variables from '@styles/variables';
import Config from '@config';
import { rem } from 'polished';
import Grid from '@atoms/Grid/Grid';

export const StyledRelatedProductsBeam = styled.div<{ $isPage?: boolean }>`
  padding: ${rem(34)} 0 ${rem(40)};

  ${(props) =>
    !props.$isPage &&
    css`
      background-color: ${variables.colors.lighterGray};
    `}

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    padding: ${rem(34)} ${rem(34)} ${rem(40)} ${rem(34)};
  }

  ${Config.MEDIA.FROM_TABLET_LANDSCAPE} {
    padding: ${rem(34)} ${rem(40)} ${rem(40)} ${rem(40)};
  }
`;

export const StyledTitleWrapper = styled.div`
  margin-bottom: ${rem(27)};
  padding: 0 ${rem(20)};

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    padding: 0;
  }
`;

export const StyledGrid = styled(Grid)`
  margin: 0 0 ${rem(26)} 0;
  padding: 0 ${rem(variables.size.containerPaddingMobileSmall)};

  ${Config.MEDIA.FROM_MOBILE} {
    padding: 0 ${rem(variables.size.containerPaddingMobile)};
  }

  ${Config.MEDIA.FROM_TABLET_LANDSCAPE} {
    grid-template-columns: repeat(4, 1fr);
  }
`;
